import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AggregateService, DataStateChangeEventArgs, GridComponent, PageSettingsModel, QueryCellInfoEventArgs, ReorderService, RowSelectEventArgs } from '@syncfusion/ej2-angular-grids';
import { IMyDpOptions } from 'mydatepicker';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DateService } from 'src/app/date.service';
import { GlobalComponent } from 'src/app/global/global.component';
import { GeneralService } from 'src/app/service/general.service';
import { EmployeeService } from '../../employee/employee.service';
import { GetBO } from '../../pages.modal';
import { DeletepermissionBO, EventEmitterBo, functionpermission, saveTimesheetBO, recalculateBo } from '../timesheet.modal';
import { TimesheetService } from '../timesheet.service';
import { TimesheetListService } from './timesheet-list.service';
import { TimesheetDateListService } from './timesheet-listdateservice';
import { TimesheetEditService } from '../timesheet-edit/timesheet-edit.service';

import { EvvTimesheetEditService } from '../../evvtimesheet/evvtimesheet-edit/evvtimesheet-edit.service';
import { BulkT2025UpdateBO } from '../../evvtimesheet/evvtimesheet.model';
@Component({
  selector: 'app-timesheet-list',
  templateUrl: './timesheet-list.component.html',
  styleUrls: ['./timesheet-list.component.scss'],
  providers: [AggregateService]
})
export class TimesheetListComponent implements OnInit {
  @ViewChild('gridTimesheet') public gridTimesheet: GridComponent;
  public GridList: Observable<DataStateChangeEventArgs>;
  showTotalamount: any;
  totalTax: any
  serviceField: string;
  public filterSettings: object;
  updateTimesheetInfo: saveTimesheetBO = new saveTimesheetBO();
  public formatOptions: object;
  updateWorkHours: any;
  payRate: any
  updateNotes: string;
  EmployeeMappedList: any = [];
  updateTimesheetDate: string;
  UpdateClient: string;
  UpdateEmployee: string;
  totalhoursSummaryMinutes: string;
  totalhoursSummary: number = 0;
  totalAmount: number;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  initialPage: PageSettingsModel;
  deletelist: DeletepermissionBO = new DeletepermissionBO();
  private onDestroy$: Subject<void> = new Subject<void>();
  TimesheetFilterBo: GetBO = new GetBO();
  AllEmployeeDropDownList: any = [];
  AllClientDropDownList: any = [];
  ClientDropDownList: any = [];
  EndDateFilter: any;
  FromDateFilter: any;
  validationError: boolean = false;
  EmployeeListFilter: any;
  ClientListFilter: any;
  DeleteForms: FormGroup;
  isTransportation: boolean = null;
  @Input() ListInputProperty: EventEmitterBo = new EventEmitterBo();
  @Output() ListOutputTimesheet = new EventEmitter<EventEmitterBo>();
  timsheetsBulkUpdateBO:BulkT2025UpdateBO =new BulkT2025UpdateBO()
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 },
    showClearDateBtn: true,
    editableDateField: true
  };
  public dropdatas: string[] = ['Yes', 'No']
  public height = '220px';
  ActiveAuthorizationList: any = [];
  serviceId: string = "00000000-0000-0000-0000-000000000000"
  authId: string = "00000000-0000-0000-0000-000000000000";
  private DecimalColumns: string[] = ["TOTALAMOUNT", "EXCEEDAMOUNT", "PAYRATE", "HOURS", "OVERTIMEHOURS", "TOTALTAXAMOUNT"];
  public AuthorizationinitialPage: PageSettingsModel;
  IsButtonDisable: boolean = false;

  constructor(public TListService: TimesheetListService,
    private CDR: ChangeDetectorRef,
    public datePipe: DatePipe,
    private employeeService: EmployeeService,
    public TService: TimesheetService,
    public DateListService: TimesheetDateListService,
    public global: GlobalComponent,
    public dateservice: DateService,
    public toasterservice: ToastrService, public general: GeneralService,public evvTimesheetSvc: EvvTimesheetEditService,
    public TEditService: TimesheetEditService) {
    this.GridList = DateListService;
    this.DeleteForms = new FormGroup({
      Password: new FormControl('', [Validators.required])
    });

  }
  fp: functionpermission = new functionpermission()
  ngOnInit(): void {
    if (this.global.globalAgencyId == null ||
      this.global.globalAgencyId == undefined ||
      this.global.globalAgencyId == "" ||
      this.global.globalAgencyId == "00000000-0000-0000-0000-000000000000") {
      return;
    }
    this.EndDateFilter = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
    this.FromDateFilter = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
    this.filterSettings = {
      type: 'Menu',
    };
    this.formatOptions = { type: 'date', format: 'MM/dd/yyyy' };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[5], pageSizes: this.pageSizes };
    this.TimesheetFilterBo.field = "client";
    this.TimesheetFilterBo.orderColumn = "client";
    this.GetClientDropDown();
    this.GetAllClientDropDown();
    this.GetAllEmployeesDropdown();
    this.getTimesheetFilter();
    this.getServiceList();
    this.getpermission()
  }
  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId != null && this.global.globalAgencyId != undefined && this.global.globalAgencyId != '')) {
      let params = new URLSearchParams();
      params.append("pagecode", "Timesheets");
      params.append("roleId", this.global.roleId);
      params.append("agencyId", this.global.globalAgencyId)
      this.employeeService.getEmployeepermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

        if (data != null) {
          this.fp = data;

        }
        else {
          this.fp = new functionpermission();
        }
      },
        (err: HttpErrorResponse) => {
          this.fp = new functionpermission();
        })
    }
  }

  validateDate() {
    if (this.FromDateFilter == null || this.FromDateFilter == '' || this.FromDateFilter == undefined) {
      this.IsButtonDisable = false;
      this.toasterservice.error("select start date");
      return;
    }
    else if (this.EndDateFilter == null || this.EndDateFilter == undefined || this.EndDateFilter == '') {
      this.IsButtonDisable = false;
      this.toasterservice.error("select end date");
      return;
    }
    else if ((this.FromDateFilter != null && this.FromDateFilter != undefined && this.FromDateFilter != '')
      && (this.EndDateFilter != null && this.EndDateFilter != undefined && this.EndDateFilter != '')) {
      if (new Date(this.FromDateFilter).getTime() > new Date(this.EndDateFilter).getTime()) {
        this.IsButtonDisable = false;
        this.toasterservice.error("End date should greater than start date");
        return;
      }
    }
  }
  //...............................................ApplyFilter....................................................
  ApplyFilter() {
    this.validateDate();
    this.TimesheetFilterBo.employee = this.EmployeeListFilter;
    this.TimesheetFilterBo.client = this.ClientListFilter;

    this.getTimesheetFilter();
  }
  RefreshFilter() {
    this.TimesheetFilterBo = new GetBO();
    this.EmployeeListFilter = null;
    this.ClientListFilter = null;;
    this.TimesheetFilterBo.field = "client";
    this.TimesheetFilterBo.orderColumn = "client";
    this.EndDateFilter = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
    this.FromDateFilter = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
    this.gridTimesheet.clearSorting();
    this.gridTimesheet.clearFiltering();
    this.getTimesheetFilter();
  }
  //........................................GetClientDropDown.............................................
  GetClientDropDown() {
    this.TListService.GetClientDropDown().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.ClientDropDownList = data;
    },
      (err: any) => {
        if (err) {
          this.toasterservice.error(err, 'Error'), 8000;
        }
      })
  }
  //........................................GetAllClientDropDown.............................................
  GetAllClientDropDown() {
    this.TListService.GetAllClientDropDown().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.AllClientDropDownList = data;
    },
      (err: any) => {
        if (err) {
          this.toasterservice.error(err, 'Error'), 8000;
        }
      })
  }

  //........................................GetAllEmployeesDropdown.............................................
  GetAllEmployeesDropdown() {
    this.TListService.GetAllEmployeesDropdown().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.AllEmployeeDropDownList = data;
    },
      (err: any) => {
        if (err) {
          this.toasterservice.error(err, 'Error'), 8000;
        }
      })
  }
  // ................................................dataChangeTimesheet..............................................
  public dataChangeTimesheet(Timesheet): void {
    let val = (Timesheet.action.requestType).toString();
    if (val != "filterchoicerequest") {
      if ((Timesheet.sorted || []).length) {
        this.TimesheetFilterBo.orderColumn = Timesheet.sorted[0].name;
        this.TimesheetFilterBo.orderType = Timesheet.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (val == "filtering" && Timesheet.action.action != "clearFilter") {

      this.TimesheetFilterBo.value = Timesheet.action.currentFilterObject.value;
      this.TimesheetFilterBo.field = Timesheet.action.currentFilterObject.field;
      this.TimesheetFilterBo.matchCase = Timesheet.action.currentFilterObject.matchCase;
      this.TimesheetFilterBo.operator = Timesheet.action.currentFilterObject.operator;
      if (Timesheet.action.currentFilterObject.field == "eTimesheet") {
        this.TimesheetFilterBo.value = this.TimesheetFilterBo.value == 'Yes' ? 'true' : 'false';
        this.TimesheetFilterBo.type = "boolean";
      }
      if (this.TimesheetFilterBo.type == "number") {
        this.TimesheetFilterBo.value = (this.TimesheetFilterBo.value != null && this.TimesheetFilterBo.value != undefined)? this.TimesheetFilterBo.value.toString():null;
      }
    }
    if((val == "filtering" && Timesheet.action.action == "clearFilter") || 
      (this.TimesheetFilterBo.type != "string" && (this.TimesheetFilterBo.value == "" 
      || this.TimesheetFilterBo.value == undefined || this.TimesheetFilterBo.value == null))){
        this.TimesheetFilterBo.field = "client";
        this.TimesheetFilterBo.matchCase = false;
        this.TimesheetFilterBo.operator = "startswith";
        this.TimesheetFilterBo.value = "";
        this.TimesheetFilterBo.type = "string";
      }
    this.getTimesheetFilter();
    if (val == "paging" && Timesheet.action.name == "actionBegin") {
      // if (this.arraycol.length != 0) {
      //   if (this.arraycol[0].Question.Pagesize != Q.take) {
      //     this.arraycol[0].Question.Pagesize = Q.take
      //     // this.SaveColumnwidth();
      //   }
      // }
    }
  }
  //.........................................onActionTimesheet.....................................................
  public onActionTimesheet(Timesheet) {
    this.TimesheetFilterBo.currentpageno = this.gridTimesheet.pagerModule.pagerObj.currentPage;
    this.TimesheetFilterBo.pageitem = this.gridTimesheet.pagerModule.pagerObj.pageSize;
    if (Timesheet.name == "actionBegin" && Timesheet.requestType == "filterbeforeopen") {
      this.TimesheetFilterBo.type = Timesheet.columnType;
    }
  }
  //.......................................DateFormat.................................................
  DateFormat(event, type, name) {
    if (type == "inputchanged") {
      if (name == 'FilterFromDate') {
        let val = this.dateservice.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let element = this.dateservice.inputFeildchangeReturnall(event);
          this.FromDateFilter = element;
        }
      }
      if (name == 'FilterToDate') {
        let val = this.dateservice.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let element = this.dateservice.inputFeildchangeReturnall(event);
          this.EndDateFilter = element;
        }
      }
      if (name == 'TimesheetDate') {
        let val = this.dateservice.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let element = this.dateservice.inputFeildchangeReturnall(event);
          this.updateTimesheetInfo.timesheetDate = element;
        }
      }
      if (name == 'StartDate') {

        let val = this.dateservice.inputFeildchangeReturnall(event);

        if (val != undefined) {

          let element = this.dateservice.inputFeildchangeReturnall(event);

          this.startenddateBo.startDate = element;

        }

      }



      if (name == 'EndDate') {

        let val = this.dateservice.inputFeildchangeReturnall(event);

        if (val != undefined) {

          let element = this.dateservice.inputFeildchangeReturnall(event);

          this.startenddateBo.endDate = element;

        }

      }

    }
    if (type == "datechanged") {
      if (name == 'FilterFromDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let element = this.dateservice.Datechange(event);
          this.FromDateFilter = element;

        }
      }
      if (name == 'FilterToDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let element = this.dateservice.Datechange(event);
          this.EndDateFilter = element;
        }
      }
      if (name == 'TimesheetDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let element = this.dateservice.Datechange(event);
          this.updateTimesheetInfo.timesheetDate = element;
        }
      }
      if (name == 'StartDate') {

        let val = this.dateservice.Datechange(event);

        if (val != undefined) {

          let element = this.dateservice.Datechange(event);

          this.startenddateBo.startDate = element;

        }

      }

      if (name == 'EndDate') {

        let val = this.dateservice.Datechange(event);

        if (val != undefined) {

          let element = this.dateservice.Datechange(event);

          this.startenddateBo.endDate = element;

        }

      }
    }
  }
  //.................................................getDetails............................................
  getDetails(list) {
    this.updateTimesheetInfo = JSON.parse(JSON.stringify(list));
    this.updateWorkHours = list.hours;
    this.serviceField = list.serviceName;
    this.serviceId = list.serviceId;
    this.isTransportation = this.updateTimesheetInfo.isTransportation == null ? false : this.updateTimesheetInfo.isTransportation;
    console.log(this.isTransportation)
    if (list.timesheetDate != null) {
      this.updateTimesheetInfo.timesheetDate = this.datePipe.transform(list.timesheetDate, 'MM/dd/yyyy');
    }
    if (list.clientId != null && list.clientId != undefined && list.clientId != '') {
      this.GetMappedEmployees();
    }
    this.totalAmount = list.totalAmount;
    this.payRate = list.payRate;
    this.authId = list.clientAuthId;
    this.getActiveAuthorization();
  }
  //..............................................getDeleteDetails................................................
  getDeleteDetails(list) {
    this.deletelist.timesheet_id = list.id;
  }
  //.........................................getTimesheetFilter.............................................
  evvtimesheet: string = ''
  getTimesheetFilter() {
    if(this.DecimalColumns.includes(this.TimesheetFilterBo.field.toUpperCase())){
      this.TimesheetFilterBo.type = "decimal";
    }
    this.TimesheetFilterBo.start = this.global.getDateTimeString(this.FromDateFilter);
    this.TimesheetFilterBo.end = this.global.getDateTimeString(this.EndDateFilter);
    this.DateListService.execute(this.TimesheetFilterBo);
    let count = 0;
    this.GridList.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      count = count + 1;
      if (data != null && data.result.length > 15) {
        this.gridTimesheet.height = '500';
      }
      else {
        this.gridTimesheet.height = 'auto';
      }
      this.totalhoursSummary = 0;
      this.showTotalamount = 0;
      this.totalTax = 0

      data?.result?.forEach(element => {
        element.eTimesheet = (element.eTimesheet == true || element.eTimesheet == 'YES') ? 'YES' : 'NO',
          this.showTotalamount += parseFloat(element.totalAmount);
        this.totalTax += parseFloat(element.totaltaxamount);
        this.totalhoursSummary = parseFloat(this.totalhoursSummary.toString()) + parseFloat(element.hours);
      });
      this.totalTax = parseFloat(this.totalTax).toFixed(2)
      this.showTotalamount = parseFloat(this.showTotalamount).toFixed(2)

      let hoursMinutes = this.totalhoursSummary.toString().split('.');
      if (hoursMinutes.length == 1) {
        this.totalhoursSummaryMinutes = hoursMinutes[0] + " hr " + "0 Min";
      }
      else {
        let minutes = 0 + "." + hoursMinutes[hoursMinutes.length - 1];
        this.totalhoursSummaryMinutes = hoursMinutes[0] + " hr " + (parseFloat(minutes) * 60).toString().split('.')[0] + "Min";
      }
    })
  }
  //....................................TimesheetEmitpage......................................................
  TimesheetEmitpage() {
    this.ListInputProperty.isCreate = true;
    this.ListInputProperty.ClientList = this.ClientDropDownList;
    this.ListOutputTimesheet.emit(this.ListInputProperty);
  }
  //....................................showTimesheetColumns......................................................
  showTimesheetColumns() {
    this.gridTimesheet.openColumnChooser(200, 50);
  }
  //.................................................DeleteTimeSheet.................................................
  DeleteTimeSheet() {
    this.IsButtonDisable = true;
    this.TListService.DeleteTimeSheet(this.deletelist).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.IsButtonDisable = false;
      this.deletelist = new DeletepermissionBO();
      this.validationError = false;
      this.toasterservice.success(
        'Timesheet deleted successfully!'
      ), 8000;
      document.getElementById("openTimesheetdeleteModal").click();
      this.ApplyFilter();
      this.validationError = false;
    },
      (err: any) => {
        this.IsButtonDisable = false;
        this.validationError = false;
        this.toasterservice.error(err);
      }
    );
  }
  //.....................................................passvalid.................................................
  passvalid(event) {
    let str = event.target.value;
    let res;
    if (str.match(/[a-z]/g) && str.match(
      /[A-Z]/g) && str.match(
        /[0-9]/g) && str.match(
          /[^a-zA-Z\d]/g) && str.length >= 8) {
      this.validationError = false;
    }
    else {
      this.validationError = true;
    }

  }
  //...................................................CancelDelete...................................................
  CancelDelete() {
    this.deletelist = new DeletepermissionBO();
  }
  //.............................................numberonly......................................................
  numberonly(event: any, TimesheetType) {
    this.CDR.detach();
    setInterval(() => {
      this.CDR.detectChanges();
    }, 10);
    if (((event.which < 48 && (event.which != 8 && event.which != 46 && event.which != 39 && event.which != 37)) || event.which > 57) && ((event.which < 96 && (event.which != 8 && event.which != 46 && event.which != 39 && event.which != 37)) || event.which > 105)) {
      event.preventDefault();
    }
    let text = "";
    if (TimesheetType == "UpdateTimesheet") {
      text = this.updateWorkHours;

    }
    text = (text.trim) ? text.trim() : text.toString().replace(/^\s+/, '');
    console.log(text.length, "text.length");
    if (text.length == 1) {
      if (text == "2") {
        if (event.key > 3) {
          event.preventDefault();
        }
      }
      if (parseInt(text) > 2) {
        if (event.which != 46) {
          event.preventDefault();
        }
      }
      if (text == ".") {
        if (
          !(
            event.which == 50 ||
            event.which == 53 ||
            event.which == 55 ||
            event.which == 48
          )
        ) {
          event.preventDefault();
        }
      }
    }
    if (text.length == 2) {
      let array = text.split("");
      if (!(array[1] == ".")) {
        if (array[0] == ".") {
          if (array[1] == "5" || array[1] == "0") {
            if (!(event.which == 48)) {
              //   event.preventDefault();
            }
          }
          if (array[1] == "2" || array[1] == "7") {
            if (!(event.which == 53)) {
              // event.preventDefault();
            }
          }
        } else if (event.which != 46) {
          event.preventDefault();
        }
      } else {
        if (
          !(
            event.which == 50 ||
            event.which == 53 ||
            event.which == 55 ||
            event.which == 48
          )
        ) {
          // event.preventDefault();
        }
      }
    }
    if (text.length == 3) {
      let array = text.split("");
      console.log(array, "array")
      if (array[0] == ".") {
        event.preventDefault();
      }
      if (array[2] == ".") {
        if (
          !(
            event.which == 50 ||
            event.which == 53 ||
            event.which == 55 ||
            event.which == 48
          )
        ) {
          // event.preventDefault();
        }
      }
      if (array[1] == ".") {
        let List = text.split(".");
        console.log(List[1], "List[1]");
        if (List[1] == "5" || List[1] == "0" || List[1] == "3") {
          if (!(event.which == 48)) {
            //  event.preventDefault();
          }
        }
        if (List[1] == "2" || List[1] == "7") {
          if (!(event.which == 53)) {
            //  event.preventDefault();
          }
        }
      }
    }
    if (text.length == 4) {
      let type = text.split(".");
      if (type[1].length == 2) {
        //  event.preventDefault();
      }
      if (type[1] == "5" || type[1] == "0") {
        if (!(event.which == 48)) {
          //  event.preventDefault();
        }
      }
      if (type[1] == "2" || type[1] == "7") {
        if (!(event.which == 53)) {
          //  event.preventDefault();
        }
      }
    }
    let val = text.split(".");
    if (text.length > 4) {
      event.preventDefault();
    }
  }
  numberonlyTrasportation(event: any, TimesheetType) {
    this.CDR.detach();
    setInterval(() => {
      this.CDR.detectChanges();
    }, 10);
    if (((event.which < 48 && (event.which != 8 && event.which != 46 && event.which != 39 && event.which != 37)) || event.which > 57) && ((event.which < 96 && (event.which != 8 && event.which != 46 && event.which != 39 && event.which != 37)) || event.which > 105)) {
      event.preventDefault();
    }
    let txt = "";
    if (TimesheetType == "UpdateTimesheet") {
      txt = this.updateWorkHours;

    }
    txt = (txt.trim) ? txt.trim() : txt.toString().replace(/^\s+/, '');
    console.log(txt.length, "text.length");
    console.log(txt, "txt");
    // length 1
    if (txt.length == 1) {
      if (txt == "10") {

        if (event.key > 4) {

          event.preventDefault();
        }

      }

      if (parseInt(txt) > 9) {

        if (event.which != 50) {
          event.preventDefault();
        }
      }
      if (txt == '.') {
        if (!(event.which == 50 || event.which == 53 || event.which == 55 || event.which == 48)) {
          event.preventDefault();
        }
      }


    }
    //  length 2
    if (txt.length == 2) {
      let tempdata = txt.split("");
      if (!(tempdata[1] == ".")) {
        if (tempdata[0] == ".") {

          if (tempdata[1] == "5" || tempdata[1] == "0") {

            if (!(event.which == 48)) {


              // event.preventDefault();
            }
          }
          if (tempdata[1] == "2" || tempdata[1] == "9") {

            if (!(event.which == 53)) {


              // event.preventDefault();
            }
          }
        }
        else if (event.which != 46) {
          //  event.preventDefault();
        }
      }
      else {

        if (!(event.which == 50 || event.which == 53 || event.which == 55 || event.which == 48)) {
          event.preventDefault();
        }
      }
    }
    // length 3
    if (txt.length == 3) {
      let tempdata = txt.split("");
      if (tempdata[0] == ".") {
        event.preventDefault();
      }
      if (tempdata[2] == ".") {

        if (!(event.which == 50 || event.which == 53 || event.which == 55 || event.which == 48)) {


          // event.preventDefault();
        }

      }
      if (tempdata[1] == ".") {

        let tempdata1 = txt.split(".");

        if (tempdata1[1] == "5" || tempdata1[1] == "0") {

          if (!(event.which == 48)) {


            //  event.preventDefault();
          }
        }
        if (tempdata1[1] == "2" || tempdata1[1] == "7") {

          if (!(event.which == 53)) {


            // event.preventDefault();
          }
        }
      }
    }
    // length 4
    if (txt.length == 4) {
      let tempdata = txt.split(".");
      if (tempdata[1].length == 2) {
        // event.preventDefault();
      }
      if (tempdata[1] == "5" || tempdata[1] == "0") {

        if (!(event.which == 48)) {


          // event.preventDefault();
        }
      }
      if (tempdata[1] == "2" || tempdata[1] == "7") {

        if (!(event.which == 53)) {


          // event.preventDefault();
        }
      }
    }
    if (txt.length > 4) {
      event.preventDefault();
    }
  }
  //.............................................CalculateTotalAmount......................................................
  CalculateTotalAmount() {

    if (this.updateWorkHours != null && this.updateWorkHours != undefined && this.updateWorkHours != '') {
      this.totalAmount = parseFloat((this.updateWorkHours * this.payRate).toFixed(2));
    }
    else {
      this.totalAmount = null;
    }
  }
  GetMappedEmployees() {
    let params = new URLSearchParams();
    params.append("clientId", this.updateTimesheetInfo.clientId);
    this.TService.GetMappedEmployees(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.EmployeeMappedList = data;
    })
  }
  //.......................................UpdateTimesheet...........................................................
  UpdateTimesheet() {
    this.IsButtonDisable = true;
    let updateBo: saveTimesheetBO = JSON.parse(JSON.stringify(this.updateTimesheetInfo));
    updateBo.id = this.updateTimesheetInfo.id;
    updateBo.hours = parseFloat(this.updateWorkHours);
    updateBo.service = this.serviceField;
    updateBo.clientAuthId = this.authId;
    updateBo.serviceId = this.serviceId;
    updateBo.payRate=this.payRate;
    let eTimesheet;
    if (this.updateTimesheetInfo.eTimesheet == "YES") {
      eTimesheet = true;
    }
    else {
      eTimesheet = false;
    }
    updateBo.eTimesheet = eTimesheet;
    updateBo.timesheetDate = this.global.getDateTimeString(this.updateTimesheetInfo.timesheetDate);
    this.TListService.UpdateTimesheet(updateBo).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.IsButtonDisable = false;
      this.toasterservice.success('Timesheet updated successfully!');
      this.getTimesheetFilter();
      setTimeout(() => {
        this.toasterservice.clear();
      }, 8000);
      document.getElementById('openUpdateTimesheetModal').click();
    }, (err: any) => {
      this.IsButtonDisable = false;
      if (err) {
        this.toasterservice.error(err, 'Error'), 8000;
      }
    })
  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }


  startenddateBo: recalculateBo = new recalculateBo()

  clearTax() {
    this.startenddateBo = new recalculateBo();
  }

  UpdateRateTimesheet() {
    this.IsButtonDisable = true;
    this.validateDate();
    let updateBo: recalculateBo = JSON.parse(JSON.stringify(this.startenddateBo));
    updateBo.startDate = this.global.getDateTimeString(this.FromDateFilter);
    updateBo.endDate = this.global.getDateTimeString(this.EndDateFilter);
    let isYearCheck=this.global.checkSameYear(updateBo.startDate,updateBo.endDate);
    if(!isYearCheck) {
      this.toasterservice.error("Please select start and end dates in the same year");
      this.IsButtonDisable = false;
      return;
    }
    updateBo.clientId = this.ClientListFilter;
    updateBo.employeeId = this.EmployeeListFilter;
    updateBo.serviceId = this.TimesheetFilterBo.service;
    this.TListService.UpdateRateTimesheet(updateBo).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.IsButtonDisable = false;
      if (data) {
        this.toasterservice.success(" timesheet updated Successfully");
        this.getTimesheetFilter()
        // document.getElementById('UpdateRatetimesheet').click();

      }

    },

      (err: any) => {
        this.IsButtonDisable = false;
        if (err) {
          this.toasterservice.error(err, 'Error'), 8000;
        }
      })

  }


  serviceList: any = []
  getServiceList() {

    this.employeeService.getServicedropDown().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.serviceList = data


    })
  }



  exportCsv() {
    this.TListService.exportcsv(this.TimesheetFilterBo).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      let contentType = 'text/csv';
      const blob = this.b64toBlob(data.fileContents, contentType);
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = "Timesheet Export";
      a.click();

    },
      (err: HttpErrorResponse) => {
        this.toasterservice.error(
          err.error

        );
      })

  }

  b64toBlob = (b64Data, contentType: any, sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

    //....................................rowSelected........................................................
    rowSelected(args: RowSelectEventArgs) {
      var rowList: any = args.data;
      this.serviceField = rowList.serviceCodeName;
      this.serviceId = rowList.serviceId;
      this.authId = rowList.id;
      this.payRate = rowList.rate;
      this.CalculateTotalAmount();
    }

  //........................................getActiveAuthorization.......................................
  getActiveAuthorization() {
    if (
      this.updateTimesheetInfo.clientId != null &&
      this.updateTimesheetInfo.clientId != undefined &&
      this.updateTimesheetInfo.clientId != "" &&
      this.updateTimesheetInfo.employeeId != null &&
      this.updateTimesheetInfo.employeeId != undefined &&
      this.updateTimesheetInfo.employeeId != "" &&
      this.updateTimesheetInfo.timesheetDate != null &&
      this.updateTimesheetInfo.timesheetDate != undefined &&
      this.updateTimesheetInfo.timesheetDate != ""
    ) {
      this.AuthorizationinitialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 5, pageSize: 5, pageSizes: [5, 10, 15, 20] };
      let params = new URLSearchParams();
      params.append("clientId", this.updateTimesheetInfo.clientId);
      params.append(
        "fromDate",
        this.global.getDateTimeString(this.updateTimesheetInfo.timesheetDate)
      );
      params.append(
        "toDate",
        this.global.getDateTimeString(this.updateTimesheetInfo.timesheetDate)
      );
      params.append("employeeId", this.updateTimesheetInfo.employeeId);      
      this.TEditService.getActiveAuthsWithinDateRange(params)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((data: any) => {
          this.ActiveAuthorizationList = data;
        });
    }
  }
  bulkUpdateService;
  bulkUpdateAuthId;
  bulkServiceId;
  //....................................rowSelected........................................................
  rowSelectedForBulkVisitUpdate(args: RowSelectEventArgs) {
    var rowList: any = args.data;
    this.bulkUpdateService = rowList.serviceCodeName;
    this.bulkServiceId = rowList.serviceId;
    this.bulkUpdateAuthId = rowList.id;

  }
  UpdateAuthorizationList: any = [];
  public UpdateAuthorizationinitialPage: PageSettingsModel;
  IsBulkUpdate: boolean = false;
  saveErr:any;
  getBulkUpdateActiveAuths() {
    this.UpdateAuthorizationinitialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: 10, pageSizes: [10, 15, 20, 25] };
    let params = new URLSearchParams();
    params.append("clientId", this.ClientListFilter);
    params.append("fromDate", this.global.getDateTimeString(this.FromDateFilter));
    params.append("toDate", this.global.getDateTimeString(this.EndDateFilter));
    this.evvTimesheetSvc.getActiveAuthsWithinDateRange(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.UpdateAuthorizationList = data;
      this.IsBulkUpdate = true;
    })
  }
  errorList:any[] = [];
  updatebulktimesheets() {
    this.IsBulkUpdate = false;
    this.IsButtonDisable = true;
   
    this.timsheetsBulkUpdateBO.clientId = this.ClientListFilter;
    this.timsheetsBulkUpdateBO.employeeId = this.EmployeeListFilter;
    this.timsheetsBulkUpdateBO.serviceId = this.TimesheetFilterBo.service;
    this.timsheetsBulkUpdateBO.updateServiceId = this.bulkServiceId;
    this.timsheetsBulkUpdateBO.updateAuthId = this.bulkUpdateAuthId;
    this.timsheetsBulkUpdateBO.startDate = this.global.getDateTimeString(this.FromDateFilter);
    this.timsheetsBulkUpdateBO.endDate = this.global.getDateTimeString(this.EndDateFilter);
    console.log(this.timsheetsBulkUpdateBO,'timsheetsBulkUpdateBO')

      this.TListService.updateMulitpleTimesheets(this.timsheetsBulkUpdateBO).pipe(takeUntil(this.onDestroy$)).
      subscribe((data: any) => {
        this.IsButtonDisable = false;
       
        if (data.length == 0) {   
          this.toasterservice.success('Timesheets Updated Successfully!');
          this.getTimesheetFilter();
          document.getElementById("updateauth").click();   
         
        } else {  
          this.errorList = data;
          if(this.errorList?.length > 0) {
            document.getElementById("errorpopup").click();   
          }
        }
      },
        (err) => {
          this.IsButtonDisable = false;
          this.toasterservice.error(err, 'error');
          setTimeout(() => {
            this.saveErr = ""
          }, 8000);
        }
      );
  }

  closeBulkUpdate() {
    this.IsBulkUpdate = false;
  }

  //................................................customiseCell.....................................................
  customiseCell(args: QueryCellInfoEventArgs) {
    if (args.column.field === 'balanceAmount') {
      if (args.data[args.column.field] < 0) {
        args.cell.classList.add('mark');
      }
    }
  }



}




